/**
 * store search condition of issue history
 */
const state = {
  searchIssueHistory: {},
  invoiceList: null
};
const getters = {
  searchIssueHistory: state => state.searchIssueHistory,
  invoiceList: state => state.invoiceList
};

const mutations = {
  changeSearchIssueHistoryInfo(state, searchIssueHistory) {
    if (!searchIssueHistory) {
      return;
    }
    if (searchIssueHistory.searchCondition) {
      state.searchIssueHistory = searchIssueHistory.searchCondition;
    }
    if (searchIssueHistory.invoiceList) {
      state.invoiceList = searchIssueHistory.invoiceList;
    }
  },
  clearSearchIssueHistory(state, deleteSearchConditionFlg) {
    if (deleteSearchConditionFlg) {
      state.searchIssueHistory = {};
    }
    state.invoiceList = null;
  },
  clearSearchConditionSearchHistory(state) {
    state.searchIssueHistory = {};
  }
};

export default {
  state,
  getters,
  mutations
};
